export default "__VITE_ASSET__BssV1YLU__"